// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/chat/v1/chat_api.proto (package gdx.gateway.web.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetGiftsRequest, GetGiftsResponse, ListIceBreakersRequest, ListIceBreakersResponse } from "./chat_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods which are related to a user chatting.
 *
 * @generated from service gdx.gateway.web.chat.v1.ChatAPI
 */
export const ChatAPI = {
  typeName: "gdx.gateway.web.chat.v1.ChatAPI",
  methods: {
    /**
     * Returns available gifts.
     *
     * @generated from rpc gdx.gateway.web.chat.v1.ChatAPI.GetGifts
     */
    getGifts: {
      name: "GetGifts",
      I: GetGiftsRequest,
      O: GetGiftsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get random ice-breakers to start conversation in chat.
     *
     * @generated from rpc gdx.gateway.web.chat.v1.ChatAPI.ListIceBreakers
     */
    listIceBreakers: {
      name: "ListIceBreakers",
      I: ListIceBreakersRequest,
      O: ListIceBreakersResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

